import styled from 'styled-components';

export const breakpoint = 768;
export const media768px = '@media (max-width: 768px)';
export const media425px = '@media (max-width: 425px)';

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2%;
`;
